/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ShowMoreFooter_connection$ref = any;
export type AnnotationStyle = "DEFAULT" | "ERROR" | "INFO" | "SUCCESS" | "WARNING" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AnnotationsList_build$ref: FragmentReference;
declare export opaque type AnnotationsList_build$fragmentType: AnnotationsList_build$ref;
export type AnnotationsList_build = {|
  +id: string,
  +uuid: string,
  +annotations: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +context: string,
        +style: ?AnnotationStyle,
        +createdAt: any,
        +priority: number,
        +body: ?{|
          +html: ?string
        |},
      |},
      +cursor: string,
    |}>,
    +$fragmentRefs: ShowMoreFooter_connection$ref,
  |},
  +$refType: AnnotationsList_build$ref,
|};
export type AnnotationsList_build$data = AnnotationsList_build;
export type AnnotationsList_build$key = {
  +$data?: AnnotationsList_build$data,
  +$fragmentRefs: AnnotationsList_build$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "RECENTLY_CREATED",
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "style"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnnotationsList_build",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "pageSize"
        },
        {
          "kind": "Variable",
          "name": "order",
          "variableName": "order"
        },
        {
          "kind": "Variable",
          "name": "style",
          "variableName": "style"
        }
      ],
      "concreteType": "AnnotationConnection",
      "kind": "LinkedField",
      "name": "annotations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AnnotationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Annotation",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "context",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "style",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "priority",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AnnotationBody",
                  "kind": "LinkedField",
                  "name": "body",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "html",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ShowMoreFooter_connection"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Build",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a246b225cf18b10e4e88d820c6f38035';

module.exports = node;
